export default "__VITE_ASSET__wJ0iDMVN__"